var r="abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ0123456789",n=r.length;function t(){for(var t="",a=32;a--;)t+=r[Math.random()*n|0];return t}export{t as uid};
//# sourceMappingURL=util-uid.module.js.map
